import React from 'react';
import { Modal, Button, Image, Typography, Space, Tag, theme } from 'antd';
import { RoomData } from '@/AppRedux/actions/admin/roomDetailConfig/roomDetailConfigType';
import { HtmlText } from '@/components/HtmlText';
import { renderTags } from './utils';
import { DEFAULT_ROOM_IMAGE } from '@/constants/AppConfig';

const { Title, Text } = Typography;

type RoomDetailModalProps = {
  room: RoomData | null;
  visible: boolean;
  onClose: () => void;
}

const RoomDetailModal: React.FC<RoomDetailModalProps> = ({ room, visible, onClose }) => {
  const { token } = theme.useToken();
  
  if (!room) return null;

  // Always use the first content entry for the modal
  const content = room.contents[0];

  return (
    <Modal
      title={<Title level={4} style={{ margin: 0 }}>{content?.display_name}</Title>}
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
      width={700}
      style={{ top: 10 }}
    >
      {content && (
        <div>
          <div style={{ marginBottom: 24 }}>
            <Image
              src={room.cover_image || DEFAULT_ROOM_IMAGE}
              width="100%"
              height={300}
              style={{ objectFit: 'cover', borderRadius: 8 }}
            />
          </div>

          <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
            <div>
              <Text type="secondary">Room Code: </Text>
              <Tag color="blue">{room.room_code}</Tag>
            </div>

            <div>
              <Text strong>Description</Text>
              <div style={{ marginTop: 8, color: token.colorTextSecondary }}>
                <HtmlText value={content.description} />
              </div>
            </div>

            {content.highlights && content.highlights.length > 0 && (
              <div>
                <Text strong>Highlights</Text>
                <div style={{ marginTop: 8 }}>
                  {renderTags(content.highlights, 'geekblue')}
                </div>
              </div>
            )}

            {content.amenities && content.amenities.length > 0 && (
              <div>
                <Text strong>Facilities</Text>
                <div style={{ marginTop: 8 }}>
                  {renderTags(content.amenities, 'green')}
                </div>
              </div>
            )}
          </Space>
        </div>
      )}
    </Modal>
  );
};

export default RoomDetailModal;
